// React import is required by make
import React from 'react';

import ListBoxItem from './ListBoxItem';
import ListBoxSection from './ListBoxSection';
import { ListBoxData, ListBoxProps, ListBoxViewProps } from './types';

export function listBoxDynamicItemRenderer<T extends ListBoxData>(
  item: T,
): React.ReactElement {
  return (
    <ListBoxItem
      icon={item.icon}
      key={item.id}
      textValue={item.textValue ?? String(item.id)}
    >
      {item.name}
    </ListBoxItem>
  );
}

export function listBoxDynamicSectionRenderer<T extends ListBoxData>(
  item: T,
): React.ReactElement {
  return (
    <ListBoxSection key={item.id} items={item.items ?? []} title={item.name}>
      {(sectionItem) => {
        return sectionItem.items
          ? listBoxDynamicSectionRenderer(sectionItem)
          : listBoxDynamicItemRenderer(sectionItem);
      }}
    </ListBoxSection>
  );
}

export function isViewProps<T extends ListBoxData>(
  props: ListBoxProps<T>,
): props is ListBoxViewProps<T> {
  return (props as ListBoxViewProps<T>).state !== undefined;
}
